module.exports = __webpack_public_path__ + "img/medical_ethics.afcbd1d6.svg";